export default function toInternationalFormat(value) {
  return new Intl.NumberFormat("en-US").format(value);
}
